import { render, staticRenderFns } from "./MapStylePropertiesCreate.vue?vue&type=template&id=8ccde4f4&scoped=true"
import script from "./MapStylePropertiesCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapStylePropertiesCreate.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MapStylePropertiesCreate.vue?vue&type=style&index=0&id=8ccde4f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccde4f4",
  null
  
)

export default component.exports